exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".attribute-element[data-v-776f28bc]{display:-ms-flexbox;display:flex;border:1px solid #000;-ms-flex-align:center;align-items:center}.attribute-element .label[data-v-776f28bc]{border-right:1px solid #000;padding:4px;min-width:100px;background-color:dimgray;color:#fff}.attribute-element .data[data-v-776f28bc]{width:100%;padding-left:6px;padding-top:2px}.result-area[data-v-776f28bc]{margin-top:2em}.exemption-player[data-v-776f28bc]{color:#775cb3;font-weight:600;font-size:12px;margin:0;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-776f28bc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Preliminary.vue
// module id = 471
// module chunks = 0